import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { IncentiveHeader } from '../../components/Incentive/IncentiveHeader';
import { IncentiveFilters } from '../../components/Incentive/IncentiveFilters';
import { IncentiveTable } from '../../components/Incentive/IncentiveTable';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { fetchIncentives, clearSuccessMessage } from '../../store/incentiveSlice';
import { exportToCSV } from '../../utils/csvExport';

export const IncentivesList: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { incentives, successMessage } = useAppSelector((state) => state.incentive);

  useEffect(() => {
    dispatch(fetchIncentives());
  }, [dispatch]);

  useEffect(() => {
    if (successMessage) {
      const timer = setTimeout(() => {
        dispatch(clearSuccessMessage());
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [successMessage, dispatch]);

  const handleExportCSV = () => {
    const headers = ['Incentive Code', 'Program Name', 'Zone', 'Cities', 'Distributor Type', 'Payout', 'Product', 'Target', 'Reward', 'Period', 'Status'];
    const rows = incentives.map((i: any) => [
      i.code || i.incentiveCode || i.id,
      i.name || '',
      i.zone || '',
      i.city || '',
      i.distType || '',
      i.payout || 'Credit',
      i.product || '',
      i.target || '',
      i.reward || '',
      i.period || i.validity || '',
      i.status || 'Active',
    ]);
    exportToCSV(`incentive_programs_${new Date().toISOString().split('T')[0]}`, headers, rows);
  };

  return (
    <div className="min-h-screen">
      {/* Toast Banner for Success Notifications */}
      {successMessage && (
        <div className="mb-4 bg-emerald-500 text-white px-4 py-3 rounded-xl shadow-md flex items-center justify-between animate-fadeIn">
          <div className="flex items-center gap-2 text-xs md:text-sm font-semibold">
            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
            </svg>
            {successMessage}
          </div>
          <button
            onClick={() => dispatch(clearSuccessMessage())}
            className="text-white/80 hover:text-white font-bold text-sm cursor-pointer"
          >
            ✕
          </button>
        </div>
      )}

      {/* Header */}
      <IncentiveHeader
        title="Distributor Incentives"
        showBack={true}
        onCreateClick={() => navigate('/incentive/create')}
        onExportCsv={handleExportCSV}
      />

      {/* Filters */}
      <IncentiveFilters />

      {/* Incentives List Table */}
      <IncentiveTable />
    </div>
  );
};
